module.exports = __webpack_public_path__ + "static/sudnay-times-light-c4d117fab93aa8d3670e5520f8e6b4a2.svg";